export const defaultBorderConfiguration = {
    defaultColor: 'none',
    hover: 'none',
    focus: 'none',
    disabled: 'none',
};
